import { useState } from 'react'
import { FilterIcon } from '../GlobalComponents/_icons/Icons'
import {
    FastQuoteInput,
    InternationalPhoneInput,
    MoneyInput,
    ToggleButtons,
    ToggledInput,
} from '../GlobalComponents/Inputs/Inputs'
import '../FastQuote/FastQuote.scss'
import { validPhone } from '../GlobalComponents/Validator'

export const FastQuoteInputStory = () => {
    return <FastQuoteInput title={'Title'} style={{ width: 200 }} />
}

export const FilterInputStory = () => {
    const [searchValue, setSearchValue] = useState<string>('')
    return (
        <FastQuoteInput
            Icon={FilterIcon}
            placeholder={'Filter Search Results'}
            value={searchValue}
            onChange={(value: string) => {
                setSearchValue(value)
            }}
            style={{ width: 200 }}
            renderEndIcon={
                searchValue
                    ? () => (
                        <div
                            style={{ width: 18, height: 15 }}
                            className={'a-i-close'}
                            onClick={() => {
                                setSearchValue('')
                            }}
                        />
                    )
                    : () => {}
            }
        />
    )
}

export const InternationalPhoneInputStory = () => {
    const [phone, setPhone] = useState<string>('')
    const [phoneFieldActive, setPhoneFieldActive] = useState<boolean>(false)

    function handlePhoneNumberBlur(e: any) {
        setPhoneFieldActive(false)
    }

    return (
        <InternationalPhoneInput
            onChange={(value: string) => {
                setPhoneFieldActive(true)
                const re = /^[0-9\b]+$/

                if (value === '' || re.test(value)) {
                    setPhone(value)
                }
            }}
            style={{ width: 200 }}
            value={phone}
            placeholder={'(___)___-____'}
            title={'Phone Number'}
            onBlur={handlePhoneNumberBlur}
            validationText={
                !phoneFieldActive && phone && !validPhone(phone) && phone !== '1'
                    ? 'Invalid Phone'
                    : ''
            }
        />
    )
}

export const MoneyInputStory = () => {
    const [money, setMoney] = useState<number>(0)
    return (
        <div style={{ width: 200 }}>
            <MoneyInput
                value={money}
                onChange={(newPrice: number) => {
                    setMoney(newPrice)
                }}
            />
        </div>
    )
}

export const ToggledInputStory = () => {
    const [value, setValue] = useState<string>('Default Value')
    return (
        <div style={{ width: 200 }}>
            <ToggledInput
                value={value}
                onChange={(newVal: string) => {
                    setValue(newVal)
                }}
            />
        </div>
    )
}

export const ToggleButtonsStory = () => {
    const [selectedIndex, setSelectedIndex] = useState<number>(0)
    return (
        <div style={{ width: 200 }}>
            <ToggleButtons
                buttonText={['Option A', 'Option B']}
                selectedIndex={selectedIndex}
                onChange={(newSelectedIndex) => setSelectedIndex(newSelectedIndex)}
            />
        </div>
    )
}
